import HttpStatus from 'http-status-codes';
// import { type Optional } from '@/types/types';
import { API_DEVELOPMENT_ORIGIN, API_BASE_PATH } from '../configuration'
// import type { Token } from '../api/model/token';

// let token: Optional<Token>;

export const JSON_MIME_TYPE = "application/json";

export enum HttpMethod {
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    HEAD = "HEAD",
    OPTIONS = "OPTIONS",
    PATCH = "PATCH",
    TRACE = "TRACE",
    CONNECT = "CONNECT"
}

/**
 * Builds the URL to an API endpoint.
 * @param path - The API endpoint path.
 * @param query - Optional Record object defining query string arguments.
 * @returns The full API endpoint URL.
 */
export const apiAddress = (path: string, query: Record<string,string> | null = null): string => {
    const host = window.location.hostname;
    let result: string;
    if (host.includes('localhost') || host.includes('127.0.0.1')) {
        result = `${API_DEVELOPMENT_ORIGIN}${API_BASE_PATH}${path}`;
    } else {
        result = `${window.location.origin}${API_BASE_PATH}${path}`;
    }
    if (query) {
        const params = new URLSearchParams(query);
        result += '?' + params.toString();
    }
    return result;
}

export const extractErrorMessage = (err: string | Error) => {
    if (typeof err === 'string') {
        return err;
    }
    return (err as Error).message;
}

export const apiErrorMessage = (response: Response): string | undefined => {
    if (response.ok) {
        return;
    }
    return `${response.status} - ${HttpStatus.getStatusText(response.status)}`;
}

export const removeSearchParamsFromUrl = () => {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, document.title, url.toString());
}
